module.exports = __webpack_public_path__ + "static/florence-1655830_1920@2x-864823e61e9ea7c7f2b5c1cfe64e717b.png";